<!--
  Renders the Resource -  Newsletter app route
-->
<template>
  <div class="row">
    <!-- Inline styles to position the image in upper right corner -->
    <div
      data-e2e-id="cis-resource-newsletter"
      style="position: relative"
      class="col-lg-12 col-md-12 col-sm-12 template-content cis-resource-newsletter"
    >
      <!-- Main Content -->
      <div class="col-lg-9 col-md-9 col-sm-12 template-main-content">
        <resource-heading
          v-bind:title="routeData.fields.resourceTitle"
          v-bind:subTitle="routeData.fields.resourceSubtitle"
        />
        <resource-content v-bind:field="routeData.fields.resourceContent" />
        <resource-downloads v-bind:fields="routeData.fields" />

        <p class="cis-resource-disclaimer">
          As of June 23, 2025, the MS-ISAC has introduced a fee-based membership. Any potential
          reference to no-cost MS-ISAC services no longer applies.
        </p>
      </div>
      <!-- Right Rail -->
      <div class="col-lg-3 col-md-3 col-sm-12 template-sidebar" :class="{ addShadow: isContent }">
        <!-- Placeholder - Right Rail Top -->
        <sc-placeholder name="jss-right-rail-top" :rendering="rendering" />

        <!-- Related Resources -->
        <related-resource v-bind:fields="routeData.fields" />

        <!-- Placeholder - Right Rail -->
        <sc-placeholder name="jss-right-rail" :rendering="rendering" />
      </div>
    </div>
  </div>
</template>

<script>
import ResourceHeading from './CIS-ResourceHeading.vue';
import ResourceContent from './CIS-ResourceContent.vue';
import ResourceDownloads from './CIS-ResourceDownloads.vue';
import RelatedResource from './CIS-ResourceRelatedResources.vue';
import { Placeholder } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Resource-Newsletter',
  props: {
    fields: {
      type: Object
    },
    rendering: {
      type: Object
    }
  },
  components: {
    ResourceContent,
    ResourceHeading,
    ResourceDownloads,
    RelatedResource,
    ScPlaceholder: Placeholder
  },
  data: function () {
    return {
      isContent: false
    };
  },
  computed: {
    routeData() {
      // this.$jss is defined on the Vue instance by the SitecoreJssPlugin and provides
      // reactive access to the root level route data provided in layout service data.
      return this.$jss.routeData();
    }
  },
  mounted() {
    if (window.innerWidth <= 991) {
      if (document.querySelector('.template-sidebar')) {
        var sideBar = document.querySelector('.template-sidebar').innerHTML;
        var newSideBar = sideBar.replace(new RegExp('<!---->', 'g'), '');

        if (newSideBar != '') {
          this.isContent = true;
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.cis-resource-newsletter {
  &:deep() {
    .download-description {
      display: none;
    }
  }
}

.template-content {
  .cis-resource-disclaimer {
    font-style: italic;
    margin: 20px 0 40px 0 !important;
  }
}
</style>
